export default __webpack_public_path__ + "static/media/d4a8421d55321198c254b9eaa4ab02e3.svg";